const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Fahrzeugschein',
	'vehicleRegistrationDocument.description':
		'Laden Sie deutliche Fotos der angeforderten Seiten des Fahrzeugscheins hoch.',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'Vorderseite des Fahrzeugscheins',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Fotografieren Sie die Vorderseite des Fahrzeugscheins deutlich.',
	'vehicleRegistrationDocument.RegistrationDocument.headline': 'Vorderseite des Fahrzeugscheins',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Vorderseite des Fahrzeugscheins - Beispiel',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Vorderseite des Fahrzeugscheins',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title': 'Rückseite des Fahrzeugscheins',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Fotografieren Sie die Rückseite des Fahrzeugscheins deutlich.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline':
		'Rückseite des Fahrzeugscheins',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Rückseite des Fahrzeugscheins - Beispiel',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Rückseite des Fahrzeugscheins',
	'vehicleRegistrationDocument.validationHeadline': 'Fehlende Fotos',
	'vehicleRegistrationDocument.validationDescription': 'Bitte fügen Sie die folgenden Fotos hinzu:',
	'landing.stepDescription.vehicleRegistrationDocument': 'Fahrzeugschein fotografieren',
	'review.stepDescription.vehicleRegistrationDocument': 'Fahrzeugschein',
	'approval.additionalCosts': 'Nebenkosten',
	'approval.calculationPDF': 'Kalkulationsbericht PDF',
	'approval.description':
		'Bitte überprüfen Sie, ob die unten angegebene Bankkontonummer korrekt ist. Wenn ja, genehmigen Sie den Kostenvoranschlag und der oben genannte Betrag wird auf Ihr Konto überwiesen.',
	'approval.headline': 'Schadenhöhe',
	'approval.labourCosts': 'Arbeitskosten',
	'approval.lacquerCosts': 'Lackierarbeiten',
	'approval.payoutAmount': 'Auszahlungsbetrag',
	'approval.repairAmount': 'Schadenhöhe',
	'approval.retention': 'Selbstbeteiligung',
	'approval.sparePartCosts': 'Ersatzteile',
	'bodyshop.headline': 'Werkstätte in Ihrer Umgebung',
	'bodyshop.mainError': 'Werkstätte in Ihrer Umgebung konnten nicht geladen werden...',
	'bodyshop.mainLoader.loadingLocation': 'Ihre Position wird bestimmt...',
	'bodyshop.mainLoader.loadingWorkshop': 'Werkstätte in Ihrer Umgebung werden geladen...',
	'button.accept': 'Akzeptieren',
	'button.addLater': 'Später hinzufügen',
	'button.backchangeImage': 'Zurück und Bild ändern',
	'button.call': 'Anrufen',
	'button.changeImage': 'Foto ändern',
	'button.close': 'Schließen',
	'button.contact': 'Kontakt',
	'button.continue': 'Fortsetzen',
	'button.dataProtection': 'Datenschutz',
	'button.deleteImage': 'Foto löschen',
	'button.help': 'Hilfe',
	'button.imprint': 'Impressum',
	'button.liveChat': 'Live-Chat',
	'button.next': 'Weiter',
	'button.start': 'Weiter',
	'button.ok': 'Ok',
	'button.onApproval': 'Kalkulation erhalten',
	'button.onCallback': 'Rückruf Notiz erhalten',
	'button.onExpertRequest': 'Expertenanfrage',
	'button.onInsuranceExpert': 'Aussteuerung an Mitarbeiter',
	'button.onLanding': 'ohne Onboarding',
	'button.onOnboarding': 'Onboarding',
	'button.onVideocall': 'Videobegutachtung',
	'button.payout': 'Ja, bitte Auszahlung',
	'button.prev': 'Zurück',
	'button.repair': 'Reparatur veranlassen',
	'button.select': 'Auswählen',
	'button.selectPhoto': 'Foto auswählen',
	'button.showTutorial': 'Tutorial ansehen',
	'button.showWhatsApp': 'WhatsApp-Nachricht',
	'calculationDetailsModal.additionalCosts': 'Nebenkosten',
	'calculationDetailsModal.labourCosts': 'Arbeitskosten',
	'calculationDetailsModal.lacquerCosts': 'Lackkosten',
	'calculationDetailsModal.spareParts': 'Ersatzteile',
	'calculationDetailsModal.total': 'Gesamt',
	'callback.description':
		'In Ihrem Fall war leider keine Kalkulation möglich. Wir rufen Sie werktags (Mo.-Fr.) in den nächsten Tagen zurück, um das weitere Vorgehen mit Ihnen zu besprächen.',
	'callback.headline': 'Ihr Schaden wurde begutachtet',
	'completeDamageDescriptionModal.description':
		'Bitte beschreiben Sie kurz, wie es zu dem Schaden gekommen ist.',
	'completeDamageDescriptionModal.headline': 'Hinweis',
	'completePayoutInformationModal.accountHolder': 'Kontoinhaber',
	'completePayoutInformationModal.accountHolderIBAN': 'IBAN des Kontoinhabers',
	'completePayoutInformationModal.description': 'Bitte fügen Sie folgende Informationen hinzu:',
	'completePayoutInformationModal.headline': 'Hinweis',
	'completePoliceReportModal.description': 'Bitte fügen Sie folgende Informationen hinzu:',
	'completePoliceReportModal.hasAccidentOnAlcoholOrDrugs': 'Alkohol- oder Drogeneinfluss',
	'completePoliceReportModal.hasAccidentOwnFault': 'Haben Sie den Unfall verursacht',
	'completePoliceReportModal.hasDamageDescription': 'Schadenbeschreibung',
	'completePoliceReportModal.hasPoliceInformed': 'Unfall polizeilich aufgenommen',
	'completePoliceReportModal.hasPoliceReportExists': 'Liegt ein Polizeibericht vor',
	'completePoliceReportModal.headline': 'Hinweis',
	'completeVehicleImagesModal.description': 'Bitte fügen Sie folgende Informationen hinzu:',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Foto Fahrzeug vorne links',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Foto Fahrzeug hinten rechts',
	'completeVehicleImagesModal.headline': 'Hinweis',
	'completeVehicleInformationModal.dashboardImage': 'Foto des Kilometerstandes',
	'completeVehicleInformationModal.description': 'Bitte fügen Sie folgende Informationen hinzu:',
	'completeVehicleInformationModal.hasValidMileage': 'Kilometerstand des Fahrzeugs',
	'completeVehicleInformationModal.headline': 'Hinweis',
	'completeVehicleInformationModal.isRegistrationDocumentUploaded': 'Foto Fahrzeugschein',
	'damageDescription.button.back': '« Zurück',
	'damageDescription.button.help': 'Hilfe',
	'damageDescription.button.next': 'Weiter »',
	'damageDescription.headline.first': 'Schadenbeschreibung',
	'damageDescription.paragraph.first':
		'Bitte beschreiben Sie kurz, wie es zu dem Schaden gekommen ist. Sie können auch die Diktierfunktion Ihres Handys nutzen. Klicken Sie dazu auf das Textfeld und halten Sie das Mikrofon-Symbol gedrückt.',
	'damageDescription.placeholder':
		'Zum Beispiel: An einer Kreuzung ist mir ein anderes Auto in die Seite gefahren. Dabei wurde mein vorderer linker Kotflügel eingedrückt.',
	'damageImages.additionalImages': 'Zusätzliche Schadenbilder',
	'damageImages.description':
		'Fügen Sie mindestens {imageCount, number} {imageCount, plural, one {Schadenfoto} other {Schadenfotos aus unterschiedlichen Entfernungen (Nahaufnahme / gesamtes Bauteil)}} hinzu. Wichtig: Der Schaden muss vollständig zu sehen sein. Anhand {imageCount, plural, one {des Bildes} other {der Bilder}} erstellen wir die Kalkulation.',
	'damageImages.headline': 'Schadendetails',
	'damageImages.optionalDamageImages':
		'Fügen Sie optional weitere Schadenbilder hinzu, die den Schaden zusätzlich dokumentieren.',
	'damageImagesExampleModal.headline': 'Schadenbilder – Beispiel',
	'dashboardImageExampleModal.headline': 'Foto Kilometerstand - Beispiel',
	enumeration: '{position, select, first {} last { und } other {, }}{enumeration}',
	'feedback.button.send': 'Feedback senden',
	'feedback.description':
		'Wir hoffen, dass Sie mit unserem Service zufrieden waren und freuen uns auf Ihr Feedback.',
	'feedback.headline': 'Danke für die Nutzung von EasyClaim!',
	'feedback.rating': 'Wie bewerten Sie die Schadenabwicklung mit EasyClaim?',
	'helpModal.description':
		'Sie kommen bei einem Schritt nicht weiter oder haben Fragen zur Anwendung? Kontaktieren Sie uns! Wir helfen Ihnen gerne weiter:',
	'helpModal.headline': 'Hilfe',
	'imageRecognitionMismatchModal.headline':
		'Sind Sie sicher, dass Sie das richtige Foto hinzugefügt haben?',
	'insuranceExpert.description':
		'Vielen Dank! Ihr Schaden wurde bewertet. Ein Mitarbeiter wird Sie zeitnah kontaktieren, um das weitere Vorgehen mit Ihnen zu besprechen.',
	'insuranceExpert.headline': 'Wir werden Sie in Kürze kontaktieren.',
	'label.details': 'Details',
	'landing.aboutEasyclaim': 'Was steckt hinter EasyClaim?',
	'landing.dataPrivacyLink': 'Nutzungsbedingungen akzeptieren',
	'landing.headline': 'In nur wenigen Schritten den KFZ-Schaden abwickeln:',
	'landing.stepDescription.damageDescription': 'Schadenhergang beschreiben',
	'landing.stepDescription.damageImages': 'Schadenbilder aufnehmen',
	'landing.stepDescription.overviewshots': 'Übersichtsaufnahmen vom Auto hinzufügen',
	'landing.stepDescription.vehicleDescription': 'Fahrzeugdetails angeben',
	'loader.error':
		'Ihr Vorgang konnte nicht geladen werden. Bitte versuchen Sie es später erneut...',
	'loader.loading': 'Daten werden geladen...',
	'mainMenu.contact': 'Kontakt',
	'mainMenu.contact.officeHours': 'Unsere Servicezeiten: Montag - Freitag 8:00 - 20:00 Uhr.',
	'mainMenu.contactDescription':
		'Haben Sie Fragen? Rufen Sie uns unter der Telefonnummer {hotlineNumber} an.',
	'mainMenu.dataPrivacy': 'Datenschutz',
	'mainMenu.description':
		'Klicken Sie auf die Schaltfläche, um die Datenschutzbestimmungen aufzurufen.',
	'mainMenu.headline': 'Datenschutz',
	'mainMenu.imprintDescription': 'Klicken Sie auf die Schaltfläche, um das Impressum aufzurufen.',
	'mainMenu.imprintLink': 'Impressum',
	'onboarding.button.finish': "Los geht's »",
	'onboarding.button.next': 'Weiter »',
	'onboarding.headline.first': 'Schadenbilder aufnehmen',
	'onboarding.headline.second': 'Kalkulieren lassen',
	'onboarding.headline.third': 'Kalkulation erhalten',
	'onboarding.link.dataPrivacy': 'Datenschutzerklärung akzeptieren',
	'onboarding.link.skip': 'Überspringen',
	'onboarding.paragraph.first':
		'Ein Kfz-Experte kalkuliert anhand der Bilder die Schadenhöhe am Fahrzeug.',
	'onboarding.paragraph.second':
		'Einfach ein Foto vom Fahrzeugschein und dem Schaden am Fahrzeug hochladen.',
	'onboarding.paragraph.third':
		'Innerhalb weniger Stunden bekommen Sie die Kalkulation zugeschickt. Sie können jetzt entscheiden: Summe auszahle oder Schaden in der Werkstatt reparieren lassen.',
	'payout.button.back': '« Zurück',
	'payout.button.help': 'Hilfe',
	'payout.button.payoutConfirm': 'Auszahlung bestätigen »',
	'payout.headline.first': 'Bankkonto',
	'payout.headline.second': 'Kontoinhaber',
	'payout.headline.third': 'IBAN',
	'payout.paragraph': 'Bitte geben Sie die Bankkontonummer für die Ausgleichszahlung an.',
	'perspective.front.left': 'vorne links',
	'perspective.front.right': 'vorne rechts',
	'perspective.rear.left': 'hinten links',
	'perspective.rear.right': 'hinten rechts',
	'registrationDocumentExampleModal.headline': 'Foto Fahrzeugschein - Beispiel',
	'resolverequest.button.continue': 'Jetzt antworten',
	'resolverequest.headline': 'Weitere Informationen benötigt',
	'resolverequest.onload': 'Lade Anfrage...',
	'resolverequest.onload.error':
		'Anfrage konnte nicht geladen werden. Bitte versuchen Sie es später noch einmal.',
	'resolverequest.question.headline': 'Wir haben eine Rückfrage',
	'review.button.back': '« Zurück',
	'review.button.close': 'Abschließen »',
	'review.button.help': 'Hilfe',
	'review.button.next': 'Weiter',
	'review.headline.first': 'Zusammenfassung',
	'review.paragraph.first':
		'Bitte überprüfen Sie Ihre Daten, bevor Sie auf „Abschließen“ klicken. Sie bekommen eine Zusammenfassung der eingegebenen Daten zugeschickt.',
	'thanksForFeedback.headline.first': 'Vielen Dank für Ihr Feedback!',
	'thanksForFeedback.paragraph.first':
		'Ihre Meinung zu unserem Service ist uns sehr wichtig. Wir arbeiten ständig daran, EasyClaim zu verbessern und Ihr Feedback ist für uns ein wichtiger Schlüssel zum Erfolg.',
	'tutorialModal.headline.first': 'Was steckt hinter EasyClaim?',
	'tutorialModal.paragraph.first':
		'EasyClaim eignet sich für nahezu alle Karosserieschäden an einem Auto. Ihre Schadenbilder und der von Ihnen geschilderte Unfallhergang werden direkt an einen unserer 350 Kfz-Meister weitergeleitet und dort analysiert und begutachtet. Unsere Kfz-Teams haben alle selbst jahrelang praktisch in der Werkstatt gearbeitet und verstehen ihr Handwerk sehr genau. Zudem prüfen wir seit über 16 Jahren Schaden- und Wartungsbelege von nahezu allen großen Versicherungen und Kfz-Herstellern. Ihre Angaben werden mit über 50 Millionen geprüften Vorgängen aus der Vergangenheit verglichen und durch das Praxis-Know-how unserer Kfz-Meister ergänzt. Zudem haben wir über die Jahre eine sehr umfangreiche Datenbank aufgebaut. Wir wissen, was jede einzelne Schraube bei jedem Autohersteller und jedem Modell kostet und welche Arbeitsschritte beim Austausch oder der Reparatur eines Autoteils notwendig sind.',
	'tutorialModal.paragraph.second':
		'All diese Umstände ermöglichen es uns, Ihnen innerhalb so kurzer Zeit einen realistischen Kostenvoranschlag zu erstellen.',
	'upload.message':
		'Ihre Daten werden hochgeladen. Abhängig von Ihrer Internetverbindung, kann dieser Vorgang mehrere Minuten in Anspruch nehmen.',
	'vehicleImages.details.first':
		'Fügen Sie ein Foto des Autos hinzu, das die gesamte vordere und linke Seite des Fahrzeugs einschließlich des vorderen Nummernschilds zeigt.',
	'vehicleImages.details.second':
		'Fügen Sie ein Foto des Autos hinzu, das die gesamte hintere und rechte Seite des Fahrzeugs einschließlich des hinteren Nummernschilds zeigt.',
	'vehicleImages.overviewPhotos': 'Fahrzeugübersicht',
	'vehicleImagesExampleModal.button.close': 'Schließen',
	'vehicleImagesExampleModal.headline.first': 'Übersichtsfotos Auto – Beispiel',
	'vehicleInformation.button.back': '« Zurück',
	'vehicleInformation.button.help': 'Hilfe',
	'vehicleInformation.button.next': 'Weiter »',
	'vehicleInformation.dashboard.paragraph':
		'Bitte machen Sie ein Foto Ihres Kilometerstandes. Sollte Ihr Fahrzeug über eine digitale Anzeige verfügen, so schalten Sie diese bitte an.',
	'vehicleInformation.headline.first': 'Fahrzeuginformationen',
	'vehicleInformation.headline.second': 'Foto Fahrzeugschein',
	'vehicleInformation.headline.third': 'Kilometerstand',
	'vehicleInformation.paragraph.first':
		'Fotografieren Sie die Innenseite Ihres Fahrzeugscheins. Anhand des Fotos können wir Ihr Fahrzeug identifizieren, indem wir z.B. die Fahrzeugidentifikationsnummer und das Erstzulassungsdatum auslesen.',
	'vehicleInformation.paragraph.second':
		'Bitte geben Sie den Kilometerstand des Fahrzeuges ein, damit wir einen genaueren Wiederbeschaffungswert ermitteln können.',
	'vehicleInformation.placeholder': 'Bsp.: 150000',
	'waitForAudit.callBack': 'Bei Rückfragen stehen wir Ihnen gerne zur Verfügung:',
	'waitForAudit.description':
		'Die Daten wurden erfolgreich übermittelt. Unsere Experten prüfen nun anhand Ihrer Daten den Schaden und erstellen innerhalb von 2 Stunden eine Kostenkalkulation (Mo-Fr 8-20 Uhr, Sa 8-12 Uhr, Feiertage ausgenommen). Sie werden per E-Mail oder SMS benachrichtigt, sobald die Berechnung abgeschlossen ist.',
	'waitForAudit.thankYou': 'Vielen Dank!',
	'withoutPayout.description':
		'Sie wünschen eine Reparatur? Gerne unterstützen wir Sie bei der Auswahl einer qualifizierten Werkstatt in Ihrer Umgebung.',
	'withoutPayout.footer':
		'Wir melden uns schnellstmöglich bei Ihnen, um das weitere Vorgehen zu besprechen.',
	'withoutPayout.headline': 'Wir unterstützen Sie gerne!',
	'timeout.bottom': ' ',
	'testcasemodal.headline': 'Testfall-Warnung!',
	'testcasemodal.accept': 'Annehmen',
	'testcasemodal.paragraph': 'Beachten Sie, dass es sich um einen Testfall handelt!',
	'testcasewarningalert.paragraph': 'Dies ist ein Testfall!',
};

export default messages;
